import ac from "assets/images/timelineImages/andersen_consulting.png";
import appLaunch from "assets/images/timelineImages/app_launch.png";
import newSite from "assets/images/timelineImages/b1337.jpg";
import bedpres from "assets/images/timelineImages/bedpres.jpg";
import firstLogo from "assets/images/timelineImages/bl-first-logo.png";
import emh from "assets/images/timelineImages/emh.jpg";
import jsgLogo from "assets/images/timelineImages/jsg.png";
import kd_2_0 from "assets/images/timelineImages/kd_2.0.jpg";
import kd_3x from "assets/images/timelineImages/kd_3x.jpg";
import kd_x2 from "assets/images/timelineImages/kd_x2.jpg";
import kd_1 from "assets/images/timelineImages/first_kd.jpg";
import jsd from "assets/images/timelineImages/jsd.jpg";
import ltLogo from "assets/images/timelineImages/lt.png";
import webLaunch from "assets/images/timelineImages/nettside_launch.png";
import pegasus from "assets/images/timelineImages/pegasus.jpg";
import otLogo from "assets/images/timelineImages/OT-logo.png";
import roadshow from "assets/images/timelineImages/roadshow.jpg";
import startLogo from "assets/images/timelineImages/start-logo.png";

interface Event {
  title: string;
  description: string;
  year: string;
  img?: string;
  btnTxt?: string;
  btnLink?: string;
}

export const timelineEvents: Event[] = [
  {
    title: "Lansering av nye nettsider vol. 2",
    description:
      "Etter mange lange kvelder, en god dose LLMs og utallige mengder pizza, lanserer vi nok en gang helt nye nettsider. De nye sidene har all den gode funksjonaliteten til de forrige sidene, men med både ny grafisk profil utviklet av Markedsføringsgruppen, og en mer moderne og langsiktig teknologistack.",
    year: "2025",
    img: pegasus,
  },
  {
    title: "Jobbsøkerguiden blir JobbsøkerDagene!",
    description:
      "En ny storsatsing for å ruste studentene til jobbsøkerprosessen. Et event over 3 dager med både startups og større bedrifter, mock-intervjuer, CV-screening, foredrag og mer!",
    year: "2024",
    img: jsd,
  },
  {
    title: "3x KarriereDagene",
    description:
      "KarriereDagene utvides ytterligere. Teltløsningen endres til en hestesko-løsning, og studenter kan nå besøke over 150 bedrifter på Frimerket i løpet av tre dager.",
    year: "2023",
    img: kd_3x,
  },
  {
    title: "Bindeleddet lanserer app",
    description: "Bindeleddets app blir tilgjengelig i App Store og Google Play.",
    year: "2018",
    img: appLaunch,
  },
  {
    title: "Lansering av nye nettsider",
    description:
      "De nye nettsidene lanseres høytidelig 2. mars 2017. De gamle nettsidene fra 18 pil og bue pensjoneres, og IT-gruppen kan igjen se seg om etter nye fritidsaktiviteter.",
    year: "2017",
    img: webLaunch,
  },
  {
    title: "Nye nettsider",
    description: "Arbidet med å utvikle helt nye nettsider begynner for alvor.",
    year: "2016",
    img: newSite,
  },
  {
    title: "2x KarriereDagen",
    description:
      "KarriereDagen utvides fra én til to dager, og får året etter navnet KarriereDagene. Besøkende kan snakke med hele 141 bedrifter på deres stands.",
    year: "2013",
    img: kd_x2,
  },
  {
    title: "En Meningsfylt Hverdag",
    description:
      "FN-sambandet og Ingeniører Uten Grenser besøker Campus Gløshaugen. De forteller hvordan studentene kan bidra til å gjøre verden til et bedre sted etter endt studium.",
    year: "2013",
    img: emh,
  },
  {
    title: "Jøbbsøkerguiden",
    description:
      "Med mål om å gjøre indøkerene bedre rustet i kampen om drømmejobben arrangeres jobbsøkerguiden for første gang. Arrangementet har siden blitt avholdt årlig.",
    year: "2011",
    img: jsgLogo,
  },
  {
    title: "KarriereDagen 2.0",
    description: "KarriereDagen flyttes fra Glassgården til det nå ikoniske teltet bak Hovedbygningen.",
    year: "2007",
    img: kd_2_0,
  },
  {
    title: "Roadshow",
    description: "Bindeleddet gjennomfører det første roadshowet for å promotere Indøk for bedrifter.",
    year: "2002",
    img: roadshow,
  },
  {
    title: "KarriereDagen",
    description: "KarriereDagen gjennomføres for første gang. 24 bedrifter deltar.",
    year: "2001",
    img: kd_1,
  },
  {
    title: "Londonturen",
    description:
      "Bindeleddet tok med Indøkstudenter for å besøke investeringsbanker i London. Londonturen ble gjentatt i 2012 og 2014",
    year: "1999",
    img: ltLogo,
  },
  {
    title: "Start-NTNU",
    description: "Bindeleddet oppretter Start-NTNU.",
    year: "1999",
    img: startLogo,
  },
  {
    title: "Diplomundersøkelsen",
    description: "Den første diplomundersøkelsen gjennomføres",
    year: "1998",
    btnTxt: "Les undersøkelsen her",
    btnLink: "/media/Diplom1998.pdf",
  },
  {
    title: "Samarbeidspartner",
    description: "Samarbeidsavtale blir inngått med Andersen Consulting, nå Accenture.",
    year: "1993",
    img: ac,
  },
  {
    title: "Osloturen",
    description: "Bindeleddet arrangerer Osloturen for første gang, som fortsatt arrangeres den dag i dag.",
    year: "1993",
    img: otLogo,
  },
  {
    title: "Bedriftspresentasjoner",
    description: "Bedriftspresentasjoner med Andersen Consulting, nå Accenture, og Aker Stord.",
    year: "1987",
    img: bedpres,
  },
  {
    title: "Skapelsen",
    description:
      "Bindeleddet stiftes av Bård Benum, sammen med Jon Arne Finnes, Tom Børre Lindholm, Jens-Erik Øvreeide og Tov Sylfest Myklatun. I dag har Bindeleddet 34 aktive medlemmer.",
    year: "1987",
    img: firstLogo,
  },
];
